module.exports = __webpack_public_path__ + "static/img/100x100_ICONS_4.3622c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/100x100_ICONS_4.png
// module id = k/23
// module chunks = 0